import { render, staticRenderFns } from "./areaPageDoctorWeb.vue?vue&type=template&id=272525b7&"
import script from "./areaPageDoctorWeb.vue?vue&type=script&lang=js&"
export * from "./areaPageDoctorWeb.vue?vue&type=script&lang=js&"
import style0 from "./areaPageDoctorWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports